import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MaterialModule } from 'src/app/core/material/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DialogCashComponent } from './dialog-cash/dialog-cash.component';
import { WithdrawCashComponent } from './withdraw-cash.component';
import { SearchPlaceComponentModule } from '../my-commerce/components/search-place/search-place.module';

@NgModule({
  declarations: [WithdrawCashComponent, DialogCashComponent],
  exports: [WithdrawCashComponent, DialogCashComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: WithdrawCashComponent
      }
    ]),
    MaterialModule,
    SharedModule,
    CommonModule,
    TranslateModule.forChild({
      isolate: false
    }),
    FormsModule,
    ReactiveFormsModule,
    SearchPlaceComponentModule,
    NgxMaskDirective,
    NgxMaskPipe
  ],
  providers: [provideNgxMask()]
})
export class WithdrawCashModule {}
